import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { InsoleComponent, insoleComponentesConfig } from '../insole-component/components-config';
import { InsoleComponentComponent } from '../insole-component/insole-component.component';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { User } from 'src/app/models/user.model';
import { PrescriptionTemplate, PrescriptionTemplatesService } from 'src/app/services/prescription-templates.service';
import { lastValueFrom, Subscription } from 'rxjs';
import { InsolesPrescriptionResponse } from 'src/app/models/formResponse.model';
import { InsolesPrescriptionMapper } from './insoles-prescription-mapper';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { toLeopoloyDesignEngine } from './insolesPrescriptionMaper';

export type LeftRightBoth = "left" | "right" | "both";

export class ValueBooleanFormGroup extends FormGroup {
  constructor(initialValue?: any) {
    super({
      value: new FormControl(initialValue?.value, Validators.required),
    });
  }
}

export class MedialLateralValueFormGroup extends FormGroup {
  constructor(initialValue?: any) {
    super({
      lateral: new FormGroup({
        value: new FormControl(initialValue?.lateral?.value, Validators.required),
      }),
      medial: new FormGroup({
        value: new FormControl(initialValue?.medial?.value, Validators.required),
      }),
    });
  }
}

export class ValueNumberAndTypeFormGroup extends FormGroup {
  constructor(initialValue?: any) {
    super({
      value: new FormControl(initialValue?.value, Validators.required),
      type: new FormControl(initialValue?.type, Validators.required),
    });
  }
}

@Component({
  selector: 'app-insoles-prescription',
  standalone: true,
  imports: [InsoleComponentComponent, SharedModule],
  templateUrl: './insoles-prescription.component.html',
  styleUrl: './insoles-prescription.component.scss'
})
export class InsolesPrescriptionComponent {
  public insoleComponents: InsoleComponent[] = []
  templatesModalVisible: boolean = false
  threeDPreviewModalVisible: boolean = false
  user: User
  prescriptionTemplates: PrescriptionTemplate[] = null
  selectedPrescriptionTemplate: PrescriptionTemplate | null = null
  insolesPrescriptionForm: FormGroup
  disabledReasons: { [key: string]: string } = {};
  warningMessages: { [key: string]: string } = {};
  token: string;
  iframeUrl: SafeResourceUrl;
  respuesta: any
  isIframeReady: boolean = false
  isLoading: boolean = true

  form: FormGroup
  leftBlobUrl: string | null = null;
  rightBlobUrl: string | null = null;

  constructor(
    private prescriptionTemplatesService: PrescriptionTemplatesService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private sanitizer: DomSanitizer,
  ) { }

  @Input() insolePrescription: any = new FormGroup({})
  @Input() clientId: string = null
  @Output() reemitEvent = new EventEmitter<any>();
  @Output() threeDPreviewVisibleChange = new EventEmitter<boolean>();
  private postingSubscriptions: Subscription[] = [];

  expandAll: boolean = false
  thicknessOptions = [2, 2.5, 3, 3.5, 4, 4.5, 5];

  ngOnInit(): void {
    this.watchGlobalBlobUrl('leftBlobUrl');
    this.watchGlobalBlobUrl('rightBlobUrl');
    this.loadComponents();
    this.checkIfClientHasTemplates();

    // Add insole type selection controls with default values
    if (!this.insolePrescription.get('shellType')) {
      this.insolePrescription.addControl('shellType', new FormControl('thin'));
    }
    if (!this.insolePrescription.get('lengthType')) {
      this.insolePrescription.addControl('lengthType', new FormControl('3-4'));
    }
    if (!this.insolePrescription.get('thinThickness')) {
      this.insolePrescription.addControl('thinThickness', new FormControl(2, [Validators.min(1), Validators.max(10)]));
    }

    // Listen for changes in shellType and lengthType to apply incompatibility rules
    this.insolePrescription.get('shellType')?.valueChanges.subscribe(() => {
      this.applyIncompatibleComponentsRules();
    });

    this.insolePrescription.get('lengthType')?.valueChanges.subscribe(() => {
      this.applyIncompatibleComponentsRules();
    });

    // Apply rules initially
    this.applyIncompatibleComponentsRules();
    this.initializePostingListeners();
  }

  ngOnDestroy() {
    delete (window as any).leftBlobUrl;
    delete (window as any).rightBlobUrl;
  }

  private watchGlobalBlobUrl(property: 'leftBlobUrl' | 'rightBlobUrl') {
    let _value = (window as any)[property];

    Object.defineProperty(window, property, {
      configurable: true,
      get() {
        return _value;
      },
      set: (val) => {
        _value = val;
        console.log(`✅ window.${property} changed:`, val);

        if (property === 'leftBlobUrl') {
          this.leftBlobUrl = val;
        } else {
          this.rightBlobUrl = val;
        }

        // Aquí puedes hacer lo que necesites:
        // por ejemplo, actualizar un iframe, disparar un evento, etc.
      },
    });

    // Si el script ya había asignado un valor antes
    if (_value) {
      if (property === 'leftBlobUrl') {
        this.leftBlobUrl = _value;
      } else {
        this.rightBlobUrl = _value;
      }
    }
  }

  async sendDataToLeopoly() {
    let question: InsolesPrescriptionResponse = {
      title: "",
      type: "insolesPrescription",
      components: []
    }

    // Obtener todos los componentes del formulario que tienen footSelection válido
    const componentsArray = this.insolePrescription.get('components') as FormArray;
    const viewerData = componentsArray.controls
      .map((formGroup: FormGroup) => formGroup.getRawValue())
      .filter((component: any) => {
        const footSelection = component.footSelection;
        return footSelection !== null && footSelection !== undefined && footSelection !== '';
      });

    console.log("viewerData: ", viewerData)

    question.components = viewerData

    const respuesta = {
      EVENT_NAME: "init_data",
      data: {
        scan_import_data: {
          right: {
            url: this.rightBlobUrl,
            format: "stl",
            scanMode: "non-weighted"
          },
          left: {
            url: this.leftBlobUrl,
            format: "stl",
            scanMode: "non-weighted"
          }
        },
        file_name_data: {
          patient_name: "Test", // Cual ponemos?
          version: 1, // Cual ponemos?
          order_id: 123 // Cual ponemos?
        },
        insole_parameters: toLeopoloyDesignEngine(
          question,
          false,
          undefined,
          this.insolePrescription.get('shellType')?.value,
          this.insolePrescription.get('lengthType')?.value,
          this.insolePrescription.get('thinThickness')?.value,
        ),
        export_URL: "test",
        embossed_logo_svg: "<svg></svg>"
      }
    };

    this.respuesta = respuesta
    // window.addEventListener("message", this.receiveMessage, false);
    // const iframe = document.getElementById("design_engine") as HTMLIFrameElement;

    // iframe.contentWindow.postMessage(respuesta, "*");


    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/design/design-engine'], { queryParams: { id: this.order.ID, data: JSON.stringify(respuesta) } })
    // );

    // window.open(url, '_blank');
  }

  loginOfLeopoly() {
    const payload = {
      "Username": environment.leopoly.three_d_preview_viewer.username,
      "Password": environment.leopoly.three_d_preview_viewer.password
    };

    this.userService.leopolyLogin3DPreviewer(payload).subscribe({
      next: (res: any) => {
        this.token = res.token;
        const safeUrl: any = this._generateSafeUrl(this.token);
        if (safeUrl) {
          this.iframeUrl = safeUrl;

          window.removeEventListener("message", this.receiveMessage, false);
          window.addEventListener("message", this.receiveMessage, false);

          console.log("Iframe cargando con token...");
          console.log("iframe url: ", this.iframeUrl)
        }
      },
      error: (err) => {
        console.error(err)
      }
    });
  }

  private _generateSafeUrl(token: string): SafeResourceUrl {
    // Construct the URL with the token
    let baseUrl = environment.leopoly.three_d_preview_viewer.base_url
    let url = `${baseUrl}?token=${token}`;

    // Sanitize the URL to make it safe
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  receiveMessage = (event: MessageEvent) => {
    console.log("Received message from iframe:", event.data);
    let iframe;

    iframe = document.getElementById("3D_previewer") as HTMLIFrameElement;

    if (event.data && event.data.EVENT_NAME === "loaded_IFrame") {
      console.log("Received loaded_IFrame");
      this.isLoading = false
      this.isIframeReady = true;
      if (this.respuesta) {
        // Limpiamos datos para evitar errores de clonación
        const safeData = JSON.parse(JSON.stringify(this.respuesta));
        iframe.contentWindow.postMessage(safeData, "*");
      }
    }

    if (event.data && event.data.EVENT_NAME === "closed_IFrame") {
      window.close();
    }
  };

  async loadComponents() {
    this.insoleComponents = insoleComponentesConfig;

    if (!this.insolePrescription) {
      let insoleComponentsConfig = insoleComponentesConfig;
      let insoleComponentsForms = [];

      // Add all the components to the components prescription form
      insoleComponentsConfig.map((component) => {
        insoleComponentsForms.push(component.form)
      })

      // Create Insoles Prescription Form
      this.insolesPrescriptionForm = this.formBuilder.group({
        type: new FormControl('insolesPrescription', { nonNullable: true }),
        components: this.formBuilder.array(insoleComponentsForms)
      })

      this.insolePrescription.setControl('type', new FormControl('insolesPrescription', { nonNullable: true }));
      this.insolePrescription.setControl('components', this.formBuilder.array(insoleComponentsForms));
      this.checkIfFirstRayCutoutAndMortonsExtension();
    }
  }

  async checkIfClientHasTemplates() {
    if (this.clientId) {
      this.prescriptionTemplates = await lastValueFrom(this.prescriptionTemplatesService.getPrescriptionTemplatesByClientID(this.clientId));
    }
  }

  toggleExpandCollapse() {
    this.expandAll = !this.expandAll
  }

  onChildFormUpdate(updatedValue: any, component: any) {
    // Reemitir el evento al siguiente padre
    this.reemitEvent.emit({ updatedValue, component });
    // Re-apply rules because child component might have called enable() internally
    this.applyIncompatibleComponentsRules();
  }

  // Método getter para obtener el FormArray de manera más sencilla en la plantilla
  get components() {
    return this.insolePrescription.get('components') as FormArray;
  }

  getFormGroupFromComponent(control: any): FormGroup {
    return control as FormGroup;
  }

  // Morton's extensions and first ray cutout are not compatible
  checkIfFirstRayCutoutAndMortonsExtension() {
    const formArray = this.insolePrescription.get('components') as FormArray;

    // Find mortons Extension component
    const mortonsExtension = formArray.controls
      .find(fg => fg.get('type').value === 'mortonsExtension') as FormGroup;

    // Find First Ray Cutout component
    const firstRayCutout = formArray.controls
      .find(fg => fg.get('type').value === 'firstRayCutout') as FormGroup;

    // Subscribe to any change in first ray cutout foot selection
    firstRayCutout.get('footSelection').valueChanges
      .subscribe(firsRayCutoutNewValue => {

        // Get the list of foot selection of Mortons exteions (left, right, both)
        // It will be used to mark as "disabled" the option
        let foundMortonsExt = this.insoleComponents.find((compToFind) => compToFind.form.get('type') === mortonsExtension.get('type'));
        // Get the value of Morton's extension foot selection
        let mortonExtensionFootSelection = mortonsExtension.get('footSelection').value

        // If the new value does not exists, that mean the foot selection is NULL
        // Then enable all the options of the Morton's extension
        if (!firsRayCutoutNewValue) {
          foundMortonsExt.footSelectionOptions.map((option) => {
            option.disabled = false;
          })
        }

        if (firsRayCutoutNewValue === "both") {
          // When First Ray is both, disable Morton's extension selectable options
          // and set al null the foot selection
          mortonsExtension.get('footSelection').setValue(null, { emitEvent: false });

          // Disable all the options for foot selection
          foundMortonsExt.footSelectionOptions.map((option) => {
            option.disabled = true;
          })

        } else if (firsRayCutoutNewValue === "right") {


          if (mortonExtensionFootSelection === "right") {
            mortonsExtension.get('footSelection').setValue(null, { emitEvent: false });
          }

          if (mortonExtensionFootSelection === "both") {
            mortonsExtension.get('footSelection').setValue("left", { emitEvent: false });
          }

          // Disable right and both options of foot selection 
          foundMortonsExt.footSelectionOptions.map((option) => {
            if (option.value === "right" || option.value === "both") {
              option.disabled = true;
            } else {
              option.disabled = false;
            }
          })

        } else if (firsRayCutoutNewValue === "left") {

          if (mortonExtensionFootSelection === "left") {
            mortonsExtension.get('footSelection').setValue(null, { emitEvent: false });
          }

          if (mortonExtensionFootSelection === "both") {
            mortonsExtension.get('footSelection').setValue("left", { emitEvent: false });
          }

          // Disable all the options for foot selection
          foundMortonsExt.footSelectionOptions.map((option) => {
            if (option.value === "left" || option.value === "both") {
              option.disabled = true;
            } else {
              option.disabled = false;
            }
          })
        }

      })


    mortonsExtension.get('footSelection').valueChanges
      .subscribe(mortonsExtensionNewValue => {
        let foundFirstRayCutoutExt = this.insoleComponents.find((compToFind) => compToFind.form.get('type') === firstRayCutout.get('type'));
        let firstRayCutoutFootSelection = mortonsExtension.get('footSelection').value
        console.log("Nuevo valor morton: ", mortonsExtensionNewValue);
        if (!mortonsExtensionNewValue) {
          foundFirstRayCutoutExt.footSelectionOptions.map((option) => {
            option.disabled = false;
          })
        }

        if (mortonsExtensionNewValue === "both") {
          firstRayCutout.get('footSelection').setValue(null, { emitEvent: false });

          // Disable all the options for foot selection
          foundFirstRayCutoutExt.footSelectionOptions.map((option) => {
            option.disabled = true;
          })

        } else {
          if (mortonsExtensionNewValue === "right") {

            if (firstRayCutoutFootSelection === "right" || firstRayCutoutFootSelection === "both") {
              firstRayCutout.get('footSelection').setValue(null, { emitEvent: false });
            }

            // Disable all the options for foot selection
            foundFirstRayCutoutExt.footSelectionOptions.map((option) => {
              console.log("deshabilito right y habilito los demás")
              if (option.value === "right" || option.value === "both") {
                option.disabled = true;
              } else {
                option.disabled = false;
              }
            })
          } else if (mortonsExtensionNewValue === "left") {

            // Disable all the options for foot selection
            foundFirstRayCutoutExt.footSelectionOptions.map((option) => {
              if (option.value === "left" || option.value === "both") {
                option.disabled = true;
              } else {
                option.disabled = false;
              }
            })
          }
        }
      })
  }

  setupSyncBetweenHeelLiftAndRearfootPosting() {
    const formArray = this.insolePrescription.get('components') as FormArray;

    // Encuentra los grupos de formulario específicos
    const rearfootPostingGroup = formArray.controls
      .find(fg => fg.get('type').value === 'rearfootPosting') as FormGroup;

    const heelLiftGroup = formArray.controls
      .find(fg => fg.get('type').value === 'heelLift') as FormGroup;

    // Asegúrate de que ambos grupos existen antes de proceder
    if (!rearfootPostingGroup || !heelLiftGroup) return;

    // Escucha cambios en 'rearfootPosting' y actualiza 'heelLift' según sea necesario
    rearfootPostingGroup.get('right.type').valueChanges
      .subscribe(value => {
        if (value === "lateralHalf" || value === "medialHalf") {
          rearfootPostingGroup.get('right.type').setValue(heelLiftGroup.get('right.type').value);
        }
      });

    // Considera también escuchar cambios en 'heelLift' si necesitas sincronización bidireccional
  }


  onSubmit(): void {
    const componentsArray = this.insolePrescription.get('components') as FormArray;
    // Filter only the componentes that the form is valid and has some foot selected
    // Because when nothing it's selected as "foot" it's always valid
    const validFormsWithFootSelection = componentsArray.controls.filter((formGroup: FormGroup) => {
      return formGroup.valid;
    });

    // Prepare array of components to request
    let componentsToRequest = [];

    // Add all the valid components to the components list
    validFormsWithFootSelection.forEach(formGroup => {
      componentsToRequest.push(formGroup.value)
    });

    // Map the data to request, and list only components "valid"
    const formData = {
      ...this.insolePrescription.value,
      components: validFormsWithFootSelection.map(component => component.value)
    };

    console.log(formData);


  }

  selectTemplate(prescriptionTemplateId: string) {
    this.templatesModalVisible = false;

    this.insolePrescription?.reset();
    (this.insolePrescription?.get('components') as FormArray)?.clear();

    if (this.insolesPrescriptionForm) {
      this.insolesPrescriptionForm.reset();
      const componentsArray = this.insolesPrescriptionForm.get('components') as FormArray;
      componentsArray?.clear();
    }

    // Encuentra la plantilla de prescripción
    this.selectedPrescriptionTemplate = this.prescriptionTemplates.find(
      (prescriptionTemplate) => prescriptionTemplate.ID === prescriptionTemplateId
    );

    let insoleComponentsConfig = insoleComponentesConfig;

    insoleComponentsConfig.forEach(component => {
      component.form.reset();
      component.form.get('footSelection')?.setValue(null, { emitEvent: false });
    });

    let insoleComponentsForms = [];

    // Add all the components to the components prescription form
    insoleComponentsConfig.map((component) => {
      insoleComponentsForms.push(component.form)
    })

    // Create Insoles Prescription Form
    this.insolesPrescriptionForm = this.formBuilder.group({
      type: new FormControl('insolesPrescription', { nonNullable: true }),
      components: this.formBuilder.array(insoleComponentsForms)
    })

    this.selectedPrescriptionTemplate.prescription as InsolesPrescriptionResponse
    this.selectedPrescriptionTemplate.prescription.components.map((insoleComponent) => {

      let componentConfig = insoleComponentsConfig.find((insoleComponentConfig) => insoleComponentConfig.form.get('type').value === insoleComponent.type);

      if (insoleComponent.left) {
        if (insoleComponent.left.value) {
          // Check if the value exists on the list, if not, then select 'others' options and apply the values
          if (componentConfig.selectOptions) {
            let foundSelecOption = componentConfig.selectOptions.find((selectOption) => selectOption.value === insoleComponent.left.value)

            if (foundSelecOption) {
              insoleComponent.left.selectedName = insoleComponent.left.value;
            } else {
              insoleComponent.left.selectedName = "others";
              insoleComponent.left.value = insoleComponent.left.value;
            }
          }
        }

        // If contains medial and not lateral that means it has to have "position"
        if ('medial' in insoleComponent.left && !('lateral' in insoleComponent.left)) {
          insoleComponent.left.position = 'medial'
        }
        if ('lateral' in insoleComponent.left && !('medial' in insoleComponent.left)) {
          insoleComponent.left.position = 'lateral'
        }

        // Flanges check
        insoleComponent = new InsolesPrescriptionMapper().rawFlangesDataToForm(['left'], insoleComponent, componentConfig);
      }


      if (insoleComponent.right) {
        if (insoleComponent.right.value) {
          // Check if the value exists on the list, if not, then select 'others' options and apply the values
          if (componentConfig.selectOptions) {
            let foundSelecOption = componentConfig.selectOptions.find((selectOption) => selectOption.value === insoleComponent.right.value)

            if (foundSelecOption) {
              insoleComponent.right.selectedName = insoleComponent.right.value;
            } else {
              insoleComponent.right.selectedName = "others";
              insoleComponent.right.value = insoleComponent.right.value;
            }
          }
        }

        // If contains medial and not lateral that means it has to have "position"
        if ('medial' in insoleComponent.right && !('lateral' in insoleComponent.right)) {
          insoleComponent.right.position = 'medial'
        }
        if ('lateral' in insoleComponent.right && !('medial' in insoleComponent.right)) {
          insoleComponent.right.position = 'lateral'
        }

        // Flanges check
        insoleComponent = new InsolesPrescriptionMapper().rawFlangesDataToForm(['right'], insoleComponent, componentConfig);
      }

      const componentsArray = this.insolesPrescriptionForm.get('components') as FormArray;
      // Encuentra los grupos de formulario específicos
      const foundComponent = componentsArray.controls
        .find(fg => fg.get('type').value === insoleComponent.type) as FormGroup;

      foundComponent.patchValue(insoleComponent);

    })

    this.insolePrescription.setControl('type', new FormControl('insolesPrescription', { nonNullable: true }));
    this.insolePrescription.setControl('components', this.formBuilder.array(insoleComponentsForms));

    // Restore shellType and lengthType from template (with defaults)
    const shellType = this.selectedPrescriptionTemplate.prescription.shellType || 'thin';
    const lengthType = this.selectedPrescriptionTemplate.prescription.lengthType || '3-4';
    const thinThicknessType = this.selectedPrescriptionTemplate.prescription.thinThickness || 2;

    this.insolePrescription.get('shellType')?.setValue(shellType);
    this.insolePrescription.get('lengthType')?.setValue(lengthType);
    this.insolePrescription.get('thinThickness')?.setValue(thinThicknessType);

    // Guardar el ID de la template aplicada
    if (!this.insolePrescription.get('prescriptionTemplateId')) {
      this.insolePrescription.addControl('prescriptionTemplateId', new FormControl(prescriptionTemplateId));
    } else {
      this.insolePrescription.get('prescriptionTemplateId')?.setValue(prescriptionTemplateId);
    }

    this.applyIncompatibleComponentsRules();
    this.initializePostingListeners();
    this.checkIfFirstRayCutoutAndMortonsExtension();
  }

  private applyIncompatibleComponentsRules(): void {
    const shellType = this.insolePrescription.get('shellType')?.value;
    const lengthType = this.insolePrescription.get('lengthType')?.value;
    const componentsArray = this.insolePrescription.get('components') as FormArray;

    const isThick = shellType === 'thick';
    const isFullOrSulcus = lengthType === 'full' || lengthType === 'sulcus';

    const thickIncompatible = ['densityReduction', 'flanges', 'archReinforcement'];
    const lengthIncompatible = ['firstRayCutout', 'mortonsExtension'];

    componentsArray.controls.forEach((group: FormGroup) => {
      const type = group.get('type')?.value;
      let shouldDisable = false;
      let reason = null;

      if (isThick && thickIncompatible.includes(type)) {
        shouldDisable = true;
        reason = 'Unavailable for Thick Shell';
      }

      if (isFullOrSulcus && lengthIncompatible.includes(type)) {
        shouldDisable = true;
        reason = `Unavailable for ${lengthType === 'full' ? 'Full Length' : 'Sulcus'}`;
      }

      if (shouldDisable) {
        if (group.enabled) {
          group.disable({ emitEvent: false });
          group.get('footSelection')?.setValue(null, { emitEvent: false });
        }
        this.disabledReasons[type] = reason;
        delete this.warningMessages[type];
      } else {
        if (group.disabled) {
          group.enable({ emitEvent: false });
        }
        delete this.disabledReasons[type];

        // Apply partial disabling / sub-field rules for Thick Shell
        if (type === 'forefootPosting') {
          this.applyForefootPostingThickRules(group, isThick);
          if (isThick) {
            this.warningMessages[type] = 'Some options are limited for Thick Shell (Filled disabled, Balanced limitations)';
          } else {
            delete this.warningMessages[type];
          }
        } else if (type === 'rearfootPosting') {
          this.applyRearfootPostingThickRules(group, isThick);
          if (isThick) {
            this.warningMessages[type] = 'Some options are limited for Thick Shell (Extrinsic and Post Type disabled)';
          } else {
            delete this.warningMessages[type];
          }
        } else {
          delete this.warningMessages[type];
        }
      }
    });
  }

  private applyForefootPostingThickRules(group: FormGroup, isThick: boolean): void {

    var footGroup: FormGroup = null;

    if (['left', 'both'].includes(group.get('footSelection').value)) {
      footGroup = group.get('left') as FormGroup;
    }

    if (['right', 'both'].includes(group.get('footSelection').value)) {
      footGroup = group.get('right') as FormGroup;
    }

    if (!footGroup) return;

    const lateralBalanced = footGroup.get('lateral.balancedToRearfoot')?.value === true;
    const medialBalanced = footGroup.get('medial.balancedToRearfoot')?.value === true;
    const anyBalanced = lateralBalanced || medialBalanced;
    const positionControl = footGroup.get('position');

    if (isThick && anyBalanced) {
      positionControl?.disable({ emitEvent: false });
    } else {
      positionControl?.enable({ emitEvent: false });
    }

    if (positionControl.value === 'medial') {
      const filledControl = footGroup.get('medial').get('filled')
      const balancedControl = footGroup.get('medial').get('balancedToRearfoot');
      if (isThick) {
        filledControl?.disable({ emitEvent: false });
        filledControl?.setValue(false, { emitEvent: false });
      } else {
        // Only enable if the parent foot is enabled
        if (footGroup.enabled) filledControl?.enable({ emitEvent: false });
      }

      if (isThick && balancedControl?.value === true) {
        footGroup.get('selectedName')?.disable({ emitEvent: false });
        footGroup.get('value')?.disable({ emitEvent: false });
        // Reset values if they are disabled
        footGroup.get('selectedName')?.setValue(null, { emitEvent: false });
        footGroup.get('value')?.setValue(null, { emitEvent: false });
      } else {
        // Rule for enabling: if not thick, or thick but not balanced
        if (!isThick || (isThick && balancedControl?.value === false)) {
          // Only enable if the side group itself should be enabled (parent foot is enabled)
          // Actually, InsoleComponentComponent manages side-level disabling, 
          // so we should only enable if it's currentlyEnabled or if we are sure.
          // But let's keep it simple: if the foot is enabled, we enable the sub-controls.
          if (footGroup.enabled) {
            footGroup.get('selectedName')?.enable({ emitEvent: false });
            footGroup.get('value')?.enable({ emitEvent: false });
          }
        }
      }
    }
  }

  private applyRearfootPostingThickRules(group: FormGroup, isThick: boolean): void {

    var footGroup: FormGroup = null;

    if (['left', 'both'].includes(group.get('footSelection').value)) {
      footGroup = group.get('left') as FormGroup;
    }

    if (['right', 'both'].includes(group.get('footSelection').value)) {
      footGroup = group.get('right') as FormGroup;
    }

    if (!footGroup) return;

    // Rule: Disable post type (group.get('left.type')) if thick
    const typeControl = footGroup.get('type');
    if (isThick) {
      typeControl?.disable({ emitEvent: false });
    } else {
      typeControl?.enable({ emitEvent: false });
    }

    const positionControl = footGroup.get('position');

    if (positionControl.value == "medial") {
      const extrinsicControl = footGroup.get('medial').get('extrinsic');
      if (isThick) {
        extrinsicControl?.disable({ emitEvent: false });
        extrinsicControl?.setValue(false, { emitEvent: false });
      } else {
        extrinsicControl?.enable({ emitEvent: false });
      }
    }

    if (positionControl.value == "lateral") {
      const extrinsicControl = footGroup.get('lateral').get('extrinsic');
      if (isThick) {
        extrinsicControl?.disable({ emitEvent: false });
        extrinsicControl?.setValue(false, { emitEvent: false });
      } else {
        extrinsicControl?.enable({ emitEvent: false });
      }
    }

  }

  private initializePostingListeners(): void {
    // Clear old subscriptions to avoid memory leaks and multiple triggers
    this.postingSubscriptions.forEach(sub => sub.unsubscribe());
    this.postingSubscriptions = [];

    const componentsArray = this.insolePrescription.get('components') as FormArray;
    if (!componentsArray) return;

    const forefootPostingGroup = componentsArray.controls.find(c => c.get('type')?.value === 'forefootPosting') as FormGroup;

    if (forefootPostingGroup) {
      ['left', 'right'].forEach(foot => {
        // Listen to balancedToRearfoot changes
        ['lateral', 'medial'].forEach(side => {
          const balancedSub = forefootPostingGroup.get(`${foot}.${side}.balancedToRearfoot`)?.valueChanges.subscribe(() => {
            this.applyIncompatibleComponentsRules();
          });
          if (balancedSub) this.postingSubscriptions.push(balancedSub);
        });

        // Listen to position changes (Medial/Lateral toggle)
        const positionSub = forefootPostingGroup.get(`${foot}.position`)?.valueChanges.subscribe(() => {
          this.applyIncompatibleComponentsRules();
        });
        if (positionSub) this.postingSubscriptions.push(positionSub);

        // Listen to footSelection changes on the group itself if needed
        // but child form update covers this
      });
    }
  }

  get hasAtLeastOneComponentSelected(): boolean {
    const componentsArray = this.insolePrescription?.get('components') as FormArray;
    if (!componentsArray) return false;

    return componentsArray.controls.some((formGroup: FormGroup) => {
      const footSelection = formGroup.get('footSelection')?.value;
      return footSelection !== null && footSelection !== undefined && footSelection !== '';
    });
  }

  on3DModalShown() {
    this.sendDataToLeopoly();
  }

  show3DPreviewModal() {
    this.respuesta = null;
    this.loginOfLeopoly()
    this.isLoading = true;
    this.threeDPreviewModalVisible = true
    this.threeDPreviewVisibleChange.emit(true);
  }

  showTemplatesModal() {
    this.templatesModalVisible = true;
  }

  onTemplatesModalClose() {
    this.templatesModalVisible = false;
  }

  on3DPreviewModalClose() {
    this.threeDPreviewModalVisible = false
    this.threeDPreviewVisibleChange.emit(false);
    this.token = null;
    this.iframeUrl = null;
    this.respuesta = null;
    this.isIframeReady = false;
    this.isLoading = true;
  }

  selectShellType(type: 'thin' | 'thick') {
    this.insolePrescription.get('shellType').setValue(type);

    if (type == 'thick') {
      this.insolePrescription.get('thinThickness').setValue(2)
    }
  }

  selectLengthType(type: '3-4' | 'sulcus' | 'full') {
    this.insolePrescription.get('lengthType').setValue(type);
  }

  selectThickness(thickness: number) {
    this.insolePrescription.get('thinThickness')?.setValue(thickness);
  }
}
